// Product Action Types
export const ProductActionTypes = {
  FETCH_PRODUCTS: "FETCH_PRODUCTS",
  CREATE_PRODUCT: "CREATE_PRODUCT",
  REMOVE_PRODUCT: "REMOVE_PRODUCT",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
  APPLY_SORTING: "APPLY_SORTING",
  FETCH_PRODUCT_BY_ID: "FETCH_PRODUCT_BY_ID",
};

// Cart Action Types
export const CartActionTypes = {
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  INCREASE_PROD_QUANTITY: "INCREASE_PROD_QUANTITY",
  DECREASE_PROD_QUANTITY: "DECREASE_PROD_QUANTITY",
};
